import script from "./Completion1OptionsGrid.vue?vue&type=script&lang=ts&setup=true"
export * from "./Completion1OptionsGrid.vue?vue&type=script&lang=ts&setup=true"

import "./Completion1OptionsGrid.vue?vue&type=style&index=0&id=39e81cde&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39e81cde"]])

export default __exports__